// extracted by mini-css-extract-plugin
module.exports = {"floral":"floral-module--floral--3Jmwd","doubleSided":"floral-module--doubleSided--7HxYu","withHero":"floral-module--withHero--2CSXz"};